import { InjectionToken } from '@angular/core';

export type ChatTypeName = '247' | 'liveperson' | 'sierra' | 'none';

export interface ChatProviderInstance {
    name: ChatTypeName;
    openChat?: (...params: any[]) => void;
    init?: (...params: any[]) => unknown;
}

export const CHAT_PROVIDER_INSTANCE = new InjectionToken<ChatProviderInstance>(
    'ChatProviderInstance',
    {
        providedIn: 'root',
        factory: () => ({
            name: 'none',
            openChat: () =>
                console.error('No ChatProviderInstance has been configured!'),
        }),
    },
);
